import React from "react";
import { Link } from "react-router-dom";
import { FiCheckCircle, FiShield, FiTrendingUp, FiDollarSign, FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import PremiumHero from "../components/common/PremiumHero";

const Box = ({ title, icon, children }) => (
  <div className="bg-white border rounded-2xl p-6">
    <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
      <span className="text-[#e11d7b]">{icon}</span> {title}
    </h3>
    <div className="text-gray-700 leading-relaxed">{children}</div>
  </div>
);

export default function Partner() {
  return (
    <div className="bg-white">
      <PremiumHero
        title="Devenir Partenaire Maxula"
        subtitle="Développez votre activité avec un réseau premium, sérieux et confidentiel"
      />

      <section className="py-14 bg-[#fff3f8]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <div className="bg-white border rounded-2xl p-6 leading-relaxed text-gray-700">
            <p className="font-medium text-gray-900">
              Avec plus de 13 ans d’expérience, Maxula accompagne les meilleurs professionnels du Maroc.
            </p>
            <p className="mt-4">
              Spas, salons, restaurants, hôtels, loisirs, services divers… et aussi médecins / cliniques (en toute discrétion).
            </p>
          </div>

          <Box title="Avantage 1 — Discrétion & protection" icon={<FiShield />}>
            <ul className="space-y-2">
              {[
                "Votre nom n’apparaît pas sur les réseaux sociaux",
                "Pas d’affichage public sur le site",
                "Le nom apparaît seulement après achat (sur le coupon)",
                "Protection de votre image & tarifs"
              ].map((x) => (
                <li key={x} className="flex items-start gap-2">
                  <FiCheckCircle className="text-[#e11d7b] mt-0.5" />
                  <span>{x}</span>
                </li>
              ))}
            </ul>
          </Box>

          <div className="grid md:grid-cols-2 gap-6">
            <Box title="Avantage 2 — Plus de clients" icon={<FiTrendingUp />}>
              <ul className="space-y-2">
                {[
                  "Campagnes marketing & promotions ciblées",
                  "Base clients active (Marocains, expatriés, touristes, VIP)",
                  "Ventes privées & réseau premium"
                ].map((x) => (
                  <li key={x} className="flex items-start gap-2">
                    <FiCheckCircle className="text-[#e11d7b] mt-0.5" />
                    <span>{x}</span>
                  </li>
                ))}
              </ul>
            </Box>

            <Box title="Avantage 3 — Paiement simple & garanti" icon={<FiDollarSign />}>
              <ul className="space-y-2">
                {[
                  "Le client vient avec un coupon",
                  "Paiement fin de mois (commission déduite)",
                  "Même coupon gratuit → vous êtes payé",
                  "Frais VIP ajoutés par Maxula n’impactent pas votre revenu"
                ].map((x) => (
                  <li key={x} className="flex items-start gap-2">
                    <FiCheckCircle className="text-[#e11d7b] mt-0.5" />
                    <span>{x}</span>
                  </li>
                ))}
              </ul>
            </Box>
          </div>

          <div className="bg-white border rounded-2xl p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Nos 3 formules</h3>

            <div className="grid md:grid-cols-3 gap-4">
              {[
                { name: "STANDARD", price: "1500 DH / an", desc: "Pour commencer • Clients réguliers • Référencement interne" },
                { name: "BOOST", price: "3500 DH / an", desc: "Visibilité renforcée • Sélections internes prioritaires" },
                { name: "PREMIUM", price: "7000 DH / an", desc: "Priorité totale • VIP & expatriés • Croissance rapide" }
              ].map((p) => (
                <div key={p.name} className="border border-pink-100 rounded-2xl p-5 bg-pink-50/60">
                  <div className="text-[#7a1147] font-extrabold">{p.name}</div>
                  <div className="text-[#e11d7b] font-bold mt-1">{p.price}</div>
                  <div className="text-sm text-gray-700 mt-2">{p.desc}</div>
                </div>
              ))}
            </div>

            <div className="mt-6 flex justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-[#e11d7b] text-white font-semibold shadow hover:shadow-lg transition"
              >
                Rejoindre Maxula
              </Link>
            </div>
          </div>

          <div className="bg-white border rounded-2xl p-6 text-sm text-gray-700">
            <h3 className="font-bold mb-3">📞 Contact Partenaires</h3>
            <p className="flex items-center gap-2"><FiMapPin className="text-[#e11d7b]" /> Avenue Beethoven, Résidence Oumnia 1, Bureau 83, Tanger</p>
            <p className="mt-2 flex items-center gap-2"><FiPhone className="text-[#e11d7b]" /> 0539 34 24 94 — 0606 06 61 62</p>
            <p className="mt-2 flex items-center gap-2"><FiMail className="text-[#e11d7b]" /> contact@maxula.ma</p>
          </div>
        </div>
      </section>
    </div>
  );
}
